<template>
  <div class="row">
    <div class="col-md-12 PageToolbar" style="padding-top:8px;">
      <vonap-toolbar-label label="Report Date">
        <report-date-picker v-model="asOfDate" @input="asOfDateChange" />
        <span v-show="historicalView">
          <select ref="fromDateDropDownList" style="width: 105px"></select>
        </span>
      </vonap-toolbar-label>
      <vonap-toolbar-label label="Sector">
        <select ref="sectorDropDownList" style="width: 170px"></select>
      </vonap-toolbar-label>
      <vonap-toolbar-label label="Division">
        <select ref="divisionDropDownList" style="width: 170px"></select>
      </vonap-toolbar-label>
      <vonap-toolbar-label label="Currency">
        <select ref="ccyPairDropDownList" style="width: 120px"></select>
      </vonap-toolbar-label>
      <label
        >Historical:<input
          type="checkbox"
          ref="historicalViewCheckBox"
          @change="asOfDateChange"
          v-model="historicalView"
      /></label>
      <slot>
        <kendo-button type="button" @click="onExport" icon="excel" title="Export to Excel" />
      </slot>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ReportDatePicker from '@/components/ReportDatePicker'
import VonapToolbarLabel from '@/components/VonapToolbarLabel'

const $ = kendo.jQuery
export default {
  components: {
    ReportDatePicker,
    VonapToolbarLabel,
  },
  props: {
    marketId: {type: Number, required: true, default: 1},
  },
  data() {
    return {
      asOfDate: new Date(),
      fromDate: new Date(),
      sectorId: -1,
      divisionId: -1,
      ccyPairId: -1,
      ccyPair: 'N/A',
      historicalView: false,
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  mounted() {
    this.getSectorDropDownList().then(() => {
      this.getDivisionDropDownList().then(() => {
        this.getCcyPairDropDownList().then(() => {
          this.getFromDateDropDownList().then(() => {
            this.$emit('change', this.getSelectedValues())
          })
        })
      })
    })
  },
  methods: {
    onExport() {
      this.$emit('export', this.getSelectedValues())
    },
    getCcyPairDropDownList() {
      const vm = this
      return new Promise(resolve => {
        $(this.$refs.ccyPairDropDownList).kendoDropDownList({
          filter: 'contains',
          dataTextField: 'ccyPair',
          dataValueField: 'ccyPairId',
          dataSource: {
            transport: {
              read: {
                type: 'GET',
                contentType: 'application/json',
                url: '/api/FlowTypeToolbar/getCcyPairs',
                data: () => ({clientId: this.clientId, marketId: this.marketId}),
              },
            },
          },
          index: 0,
          change: e => {
            vm.ccyPairId = e.sender.value()
            vm.ccyPair = e.sender.text()
            vm.$emit('change', this.getSelectedValues())
          },
          dataBound: function() {
            this.select(0)
            vm.ccyPairId = this.value()
            vm.ccyPair = this.text()
            resolve()
          },
        })
      })
    },
    getSectorDropDownList() {
      const vm = this
      return new Promise(resolve => {
        $(this.$refs.sectorDropDownList).kendoDropDownList({
          filter: 'contains',
          dataTextField: 'sector',
          dataValueField: 'sectorId',
          dataSource: {
            transport: {
              read: {
                url: '/api/report/ExposureToolbar/GetUserSectors',
                cache: false,
                data: function() {
                  return {
                    clientId: vm.clientId,
                  }
                },
              },
            },
          },
          index: 0,
          change: e => {
            vm.sectorId = e.sender.value()
            const divisionDropDownList = $(this.$refs.divisionDropDownList).getKendoDropDownList()

            divisionDropDownList.dataSource.read().then(function() {
              divisionDropDownList.select(0)
              divisionDropDownList.trigger('change')
            })
          },
          dataBound: function() {
            this.select(0)
            vm.sectorId = this.value()
            resolve()
          },
        })
      })
    },
    asOfDateChange() {
      const vm = this

      vm.historicalView = $(vm.$refs.historicalViewCheckBox).is(':checked')

      const fromDateDropDownList = $(vm.$refs.fromDateDropDownList).getKendoDropDownList()
      if (!vm.historicalView) {
        this.$emit('change', vm.getSelectedValues())
        return
      }
      if (fromDateDropDownList == null) return
      fromDateDropDownList.dataSource.read().then(function() {
        fromDateDropDownList.select(0)
        fromDateDropDownList.trigger('change')
      })
    },
    getDivisionDropDownList() {
      const vm = this
      return new Promise(resolve => {
        $(this.$refs.divisionDropDownList).kendoDropDownList({
          filter: 'contains',
          dataTextField: 'divisionName',
          dataValueField: 'divisionId',
          dataSource: {
            transport: {
              read: {
                url: '/api/report/ExposureToolbar/GetUserDivisions',
                cache: false,
                data: function() {
                  return {
                    sectorId: vm.sectorId,
                    clientId: vm.clientId,
                  }
                },
              },
            },
          },
          index: 0,
          change: e => {
            vm.divisionId = e.sender.value()
            vm.$emit('change', this.getSelectedValues())
          },
          dataBound: function() {
            this.select(0)
            vm.divisionId = this.value()
            resolve()
          },
        })
      })
    },
    getFromDateDropDownList() {
      const vm = this
      return new Promise(resolve => {
        $(this.$refs.fromDateDropDownList).kendoDropDownList({
          dataTextField: 'periodCode',
          dataValueField: 'toDate',
          dataSource: {
            transport: {
              read: {
                type: 'get',
                url: '/api/report/ExposureToolbar/GetOrderFromPeriods',
                cache: false,
                data: function() {
                  return {
                    clientId: vm.clientId,
                    asOfDate: kendo.toString(vm.asOfDate, 'yyyy-MM-dd'),
                    historical: vm.historicalView,
                  }
                },
              },
            },
          },
          index: 0,
          change: e => {
            vm.fromDate = e.sender.value()
            this.$emit('change', vm.getSelectedValues())
          },
          dataBound: function() {
            this.select(0)
            vm.fromDate = this.value()
            resolve()
          },
        })
      })
    },
    getSelectedValues() {
      const vm = this
      return {
        clientId: vm.clientId,
        asOfDate: kendo.toString(vm.asOfDate, 'yyyy-MM-d'),
        fromDate: kendo.toString(vm.fromDate, 'yyyy-MM-d'),
        sectorId: vm.sectorId,
        divisionId: vm.divisionId,
        ccyPairId: vm.ccyPairId,
        ccyPair: vm.ccyPair,
        historical: vm.historicalView,
      }
    },
  },
}
</script>
